export const theme = {
  primary: "black",
  primaryLight: "#222222", // lighter black egzample: footer
  secondary: "#9AC7C4", // blue :hover links, social icons
  secondaryLight: "#F0F1F2", // light  backround
  secondaryDark: "rgb(61, 170, 163)", // Text active links
  bright: "#ffffff", // white
  grey: "#D3D3D3",
  lightGrey: "#f5f5f5", // photos background
  font: {
    size: {
      s: "0.8rem", // 14px
      r: "1rem", // 16px
      ms: "1.13rem", //18px
      m: "1.25rem", //20px
      l: "1.5rem", //24px
      xl: "2.2rem", //35px
      xxl: "3.45rem", //55px,\
      xxxl: "4.40rem",
    },
    family: {
      main: "'Roboto', sans-serif",
      second: "'Inconsolata', monospace",
    },
    weight: {
      thin: "200",
      regular: "400",
      bold: "600",
    },
    line: {
      s: "1.3",
    },
  },
  mq: {
    tablet: "@media(min-width: 700px)",
    laptop: "@media(min-width: 1200px)",
  },
}
